// src/components/AboutPage.tsx
import React from "react";
import Footer from "../components/Footer";

const ErrorPage: React.FC = () => {
  return (
    <div>
      <div>
        <h1>404</h1>
        {/* Add your content here */}
      </div>
      <Footer></Footer>
    </div>
  );
};

export default ErrorPage;
